import { render, staticRenderFns } from "./DonutsWidget.vue?vue&type=template&id=70eb267a&scoped=true"
import script from "./DonutsWidget.vue?vue&type=script&lang=js"
export * from "./DonutsWidget.vue?vue&type=script&lang=js"
import style0 from "./DonutsWidget.vue?vue&type=style&index=0&id=70eb267a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eb267a",
  null
  
)

export default component.exports